import React, { useEffect, useState } from 'react';
import {
  Typography,
  Box,
  CircularProgress,
  Paper,
  Divider,
  MenuItem,
  FormControl,
  Select,
  InputLabel,
  Button
} from '@mui/material';
import { useParams } from 'react-router-dom';
import PlayerCharts from '../components/PlayerCharts';

const AdminPlayerDetailPage = () => {
  const { userId } = useParams();

  const [summary, setSummary] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filterOptions, setFilterOptions] = useState({ weeks: [], drills: [] });
  const [selectedWeek, setSelectedWeek] = useState('');
  const [selectedDrill, setSelectedDrill] = useState('');
  const [drillData, setDrillData] = useState([]);
  const [weeklyData, setWeeklyData] = useState([]);


  const token = localStorage.getItem('token');
  const fetchFilterOptions = async () => {
    try {
      const res = await fetch(`http://localhost:8000/workout-log/${userId}/filter-options`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const options = await res.json();
      setFilterOptions(options);
    } catch (err) {
      console.error('Error fetching filter options', err);
    }
  };
  
  useEffect(() => {
    const fetchInitialSummary = async () => {
      try {
        const res = await fetch(`http://localhost:8000/workout-log/${userId}/summary`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const data = await res.json();
        setSummary(data);
  
        const weeklyRes = await fetch(`http://localhost:8000/workout-log/${userId}/weekly-summary`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const weekly = await weeklyRes.json();
        setWeeklyData(weekly);
  
        const drillRes = await fetch(`http://localhost:8000/workout-log/${userId}/drill-summary`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        const drills = await drillRes.json();
        setDrillData(drills);
  
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };
  
    fetchInitialSummary();   
    fetchFilterOptions();    
  }, [userId, token]);       
  

  const handleFilter = async () => {
    try {
      console.log("Apply Filter Clicked");
      console.log("Selected Week:", selectedWeek);
      console.log("Selected Drill:", selectedDrill);
  
      const params = new URLSearchParams();
      if (selectedWeek) params.append('week', selectedWeek);
      if (selectedDrill) params.append('drill', selectedDrill);
  
      console.log("Filter Params:", params.toString());
  
      const res = await fetch(`http://localhost:8000/workout-log/${userId}/filtered-summary?${params}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
  
      const filtered = await res.json();
      console.log("Filtered summary response:", filtered);
  
      setSummary(filtered);
    } catch (err) {
      console.error('Error applying filter', err);
    }
  };
  

  if (loading) return <CircularProgress sx={{ mt: 5 }} />;

  return (
    <Box sx={{ mt: 5, maxWidth: 600, mx: 'auto' }}>
      <Paper sx={{ p: 4 }}>
        <Typography variant="h5" gutterBottom>
          Player Summary (User ID: {userId})
        </Typography>
        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
          <FormControl fullWidth>
            <InputLabel>Week</InputLabel>
            <Select value={selectedWeek} label="Week" onChange={(e) => setSelectedWeek(e.target.value)}>
              <MenuItem value=""><em>All</em></MenuItem>
              {filterOptions?.weeks?.map((week) => (
                <MenuItem key={week} value={week}>{week}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <FormControl fullWidth>
            <InputLabel>Drill</InputLabel>
            <Select value={selectedDrill} label="Drill" onChange={(e) => setSelectedDrill(e.target.value)}>
              <MenuItem value=""><em>All</em></MenuItem>
              {filterOptions?.drills?.map((drill) => (
                <MenuItem key={drill} value={drill}>{drill}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        <Button variant="contained" onClick={handleFilter} sx={{ mb: 3 }}>
          Apply Filter
        </Button>

        <Typography><strong>Total Drills Logged:</strong> {summary.drills_completed ?? 0}</Typography>
        <Typography><strong>Total Makes:</strong> {summary.total_makes ?? 0}</Typography>
        <Typography><strong>Total Attempts:</strong> {summary.total_attempts ?? 0}</Typography>
        <Typography><strong>Shooting %:</strong> {summary.shooting_pct ?? 0}</Typography>
        <Typography><strong>Last Submission:</strong> {summary.last_submission_date ?? 'N/A'}</Typography>
      </Paper>

      <PlayerCharts weeklyData={weeklyData} drillData={drillData} role="admin" />

    </Box>
  );
};

export default AdminPlayerDetailPage;

